export const splitPath = (path: string): string[] => {
  const segments = path.split('/')
  const result = segments.reduce((acc: string[], segment) => {
    if (segment !== '') {
      if (acc.length > 0) {
        acc.push(acc[acc.length - 1] + '/' + segment)
      } else {
        acc.push('/' + segment)
      }
    }
    return acc
  }, [])
  return result
}
